// Base da API Oplena. Em produção defina REACT_APP_URL_API (ex.: https://api.oplena.com.br/).
// Sem trailing slash aqui (os resources fazem `${API_URL}/oplena/...`).
module.exports = {
  api: {
    API_URL: (process.env.REACT_APP_URL_API || "http://localhost:48000/").replace(/\/+$/, ""),
  }
};